import { EMPTY_STRING } from "common/constants";

export interface IPerson {
  firstName?: string;
  middleName?: string;
  lastName?: string;
}

export const getPersonFullName = (
  person: IPerson,
  format: string = "%F %M %L"
): string => {
  if (person) {
    const firstName = person.firstName?.trim() || EMPTY_STRING;
    const middleName = person.middleName?.trim() || EMPTY_STRING;
    const lastName = person.lastName?.trim() || EMPTY_STRING;

    return format
      .replace(/%F/g, firstName)
      .replace(/%L/g, lastName)
      .replace(/%M/g, middleName)
      .replace(/%f/g, firstName ? firstName.substr(0, 1) + "." : EMPTY_STRING)
      .replace(/%l/g, lastName ? lastName.substr(0, 1) + "." : EMPTY_STRING)
      .replace(/%m/g, middleName ? middleName.substr(0, 1) + "." : EMPTY_STRING)
      .replace(/\s+/g, " ");
  }
};
